export function parseFormData(parameter = {}) {
  return {
    name: parameter.name,
    description: parameter.description,
    parameter: parameter.parameter,
    value: parameter.value,
  };
}
